
import React, { useState, useEffect } from "react";
import Loader from "../../../components/ui/Loader/Loader";
import HttpAPICall from "../../../services/HttpAPICall";
import { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { DisplayListPagination } from "../../../components/TapUi";
import { useSelector } from "react-redux";

const DemandHistoryContent = ({ itemData, workstation_id, asset_id, demand_for }) => {
    const access_token = useSelector(state => state.auth.access_token);

    const [loading, setLoading] = useState(false);
    const [demandHistoryList, setDemandHistoryList] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [itemName, setItemName] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const fetchDemandHistoryData = (page = 1) => {
        if (!itemData) return;

        setLoading(true);
        setCurrentPage(page);

        let params = {
            search_item_ids: [itemData.id],
            page: page,
            action: 'data',
            for_report: 'N',
        };

        if (asset_id) params.search_asset_ids = [asset_id];
        if (demand_for) params.demand_for = demand_for;

        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/item_demand/report/item-wise',
            access_token, { ...params }, {},
            (response) => {
                let respData = response.data;
                setDemandHistoryList(respData.data || []);
                setListingMeta(respData);
                setItemName(itemData.name || '');
                setItemCode(itemData.item_code || '');
                setLoading(false);
            }).then(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (itemData) {
            fetchDemandHistoryData(1);
        }
    }, [itemData, workstation_id, asset_id]);

    const handlePageChange = (e) => {
        fetchDemandHistoryData(e.selected + 1);
    };

    return (
        <>
            <div className='p-1 bg-light border-bottom'>
                <table className='table table-sm mb-0 table-borderless text-sm'>
                    <tbody>
                        <tr>
                            <td style={{ width: "15%" }}>Item Name</td>
                            <th>{itemName || "-"}</th>
                        </tr>
                        <tr>
                            <td style={{ width: "15%" }}>Item Code</td>
                            <th>{itemCode || "-"}</th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mt-3">
                {loading ? (
                    <div className="text-center py-5">
                        <Loader />
                    </div>
                ) : (
                    <>
                        <div style={{ maxHeight: "330px", overflowY: "auto", marginTop: "8px", marginBottom: "8px" }}>
                            <table className="table table-bordered table-sm align-middle bg-white table-fixed">
                                <thead className="align-middle table-secondary">
                                    <tr>
                                        <th className='text-center' style={{ width: "12%" }}>Transaction Date</th>
                                        <th className='text-center' style={{ width: "10%" }}>Transaction ID</th>
                                        <th className="text-center" style={{ width: "22%" }}>Warehouse</th>
                                        <th className="text-center" style={{ width: "20%" }}>Demand For</th>
                                        <th scope="col" style={{ width: "8%" }}>Status</th>
                                        <th scope="col" style={{ width: "6%" }}>Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {demandHistoryList.length > 0 ? (
                                        demandHistoryList.map((rowData, k) => (
                                            <tr key={k}>
                                                <td className='text-center'>{rowData.transaction_date || "-"}</td>
                                                <td className='text-center'> {rowData.transaction_id || "-"} </td>
                                                <td>{rowData.warehouse?.name || "-"}</td>
                                                <td>
                                                    {rowData.demand_for === 'asset' && rowData.asset?.name && `${rowData.asset.name} `}
                                                    {rowData.demand_for === 'workstation' && rowData.workstation?.workstation_name && `${rowData.workstation.workstation_name} `}
                                                    {rowData.demand_for === 'sub_assembly' && rowData.sub_assembly?.name && `${rowData.sub_assembly.name} `}
                                                    {rowData.demand_for === 'employee' && rowData.employee?.display_full_name && `${rowData.employee.display_full_name} `}
                                                    ({rowData.demand_for === 'asset' ? 'Asset' :
                                                        rowData.demand_for === 'workstation' ? 'Workstation' :
                                                            rowData.demand_for === 'sub_assembly' ? 'Sub Assembly' : 'Employee'})
                                                </td>
                                                <td>{rowData.status?.name || "-"}</td>
                                                <td className="text-center">{rowData.qty || 0}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="text-center" colSpan={6}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                            <DisplayListPagination
                                meta={listingMeta}
                                onPageChange={handlePageChange}
                            />
                    </>
                )}
            </div>
        </>
    );
};

export default DemandHistoryContent;